/**
 * Toast flotante al añadir al carrito + sincronización del contador (AJAX).
 */
(function () {
  var TOAST_DURATION = 5000;
  var host = null;
  var timer = null;
  var activeToast = null;

  var SUCCESS_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M14.25 5.25 7.5 12 3.75 8.25" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ERROR_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M9 6v4M9 13h.01" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><circle cx="9" cy="9" r="7" stroke="currentColor" stroke-width="1.5"/></svg>';

  function ensureHost() {
    if (host) return host;
    host = document.createElement('div');
    host.id = 'oleum-cart-toast-host';
    host.className = 'oleum-cart-toast-host';
    host.setAttribute('aria-live', 'polite');
    host.setAttribute('aria-atomic', 'true');
    document.body.appendChild(host);
    return host;
  }

  function hideToast() {
    if (!activeToast) return;
    activeToast.classList.remove('is-visible');
    activeToast.classList.add('is-leaving');
    var node = activeToast;
    activeToast = null;
    clearTimeout(timer);
    timer = null;
    setTimeout(function () {
      if (node.parentNode) node.parentNode.removeChild(node);
    }, 280);
  }

  function refreshCartUI(knownCount) {
    var cartBase = (window.routes && window.routes.cart_url) || '/cart';
    var cartUrl = cartBase.indexOf('.js') !== -1 ? cartBase : cartBase.replace(/\/$/, '') + '.js';

    return fetch(cartUrl, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var count =
          typeof knownCount === 'number' && !isNaN(knownCount) ? knownCount : cart.item_count;
        patchCartCountBadges(count);
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: '',
              data: {
                itemCount: count,
                source: 'oleum-product-card',
              },
            },
          })
        );
        return cart;
      })
      .catch(function () {
        if (typeof knownCount === 'number' && !isNaN(knownCount)) {
          patchCartCountBadges(knownCount);
        }
        return null;
      });
  }

  function patchCartCountBadges(count) {
    if (typeof count !== 'number' || isNaN(count)) return;
    var label = count <= 0 ? '0' : count >= 100 ? '99+' : String(count);

    document.querySelectorAll('[data-testid="cart-bubble"]').forEach(function (el) {
      el.textContent = count >= 100 ? '' : label;
      el.classList.toggle('hidden', count <= 0);
      var bubble = el.closest('.cart-bubble');
      if (bubble) bubble.classList.toggle('visually-hidden', count <= 0);
    });

    document.querySelectorAll('cart-icon').forEach(function (icon) {
      icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    });

    document.querySelectorAll('[data-oleum-bottom-nav-cart-badge]').forEach(function (badge) {
      var countEl = badge.querySelector('[data-oleum-bottom-nav-cart-count]');
      if (!countEl) return;
      countEl.textContent = label;
      badge.classList.toggle('oleum-bottom-nav__cart-badge--empty', count <= 0);
    });

    try {
      sessionStorage.setItem(
        'cart-count',
        JSON.stringify({
          value: String(count),
          timestamp: Date.now(),
        })
      );
    } catch (err) {
      /* ignore */
    }
  }

  window.showCartToast = function (message, type, subtitle) {
    var isError = type === 'error';
    var title = message || (isError ? 'No se pudo añadir' : '¡Añadido a la bolsa!');
    var detail =
      subtitle ||
      (isError ? 'Intenta de nuevo en un momento.' : 'Tu producto se agregó al carrito con éxito.');

    ensureHost();
    hideToast();

    var toast = document.createElement('div');
    toast.className = 'oleum-cart-toast oleum-cart-toast--' + (isError ? 'error' : 'success');
    toast.setAttribute('role', 'status');
    toast.innerHTML =
      '<span class="oleum-cart-toast__icon" aria-hidden="true">' +
      (isError ? ERROR_ICON : SUCCESS_ICON) +
      '</span>' +
      '<span class="oleum-cart-toast__text"><strong>' +
      title +
      '</strong><span>' +
      detail +
      '</span></span>';

    toast.addEventListener('click', hideToast);
    host.appendChild(toast);
    activeToast = toast;

    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    timer = setTimeout(hideToast, TOAST_DURATION);
  };

  window.refreshOleumCartUI = refreshCartUI;

  document.addEventListener('cart:refresh', refreshCartUI);
})();
